import './InGameNotifications.css';
import { useInGameNotificationContext } from './InGameNotificationContext.tsx';

export function InGameNotifications() {
    const { notifications } = useInGameNotificationContext();
    return (
        <div className='in-game-notification-container'>
            {notifications.map((notification, idx) => (
                <div key={notification.id} className='in-game-notification'>
                    {notification.message}
                </div>
            ))}
        </div>
    );
}
